import { supabase } from "@/integrations/supabase/client";

export interface CategoryRecord {
  id: string;
  name: string;
  slug: string;
  color: string | null;
}

export async function getOrCreateCategoryByName(
  name: string
): Promise<CategoryRecord | null> {
  const trimmed = name?.trim();
  if (!trimmed) return null;

  // Try to find an existing category by case-insensitive name match
  const { data: existing, error: selectError } = await supabase
    .from("categories")
    .select("id, name, slug, color")
    .ilike("name", trimmed)
    .maybeSingle();

  // If an unexpected error occurred, surface it
  if (selectError && selectError.code !== "PGRST116") {
    console.error("Error looking up category by name:", selectError);
    throw selectError;
  }

  if (existing) {
    return existing as CategoryRecord;
  }

  const slug = trimmed
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

  const { data: created, error: insertError } = await supabase
    .from("categories")
    .insert({
      name: trimmed,
      slug,
    })
    .select("id, name, slug, color")
    .single();

  if (insertError) {
    console.error("Error creating category:", insertError);
    throw insertError;
  }

  return created as CategoryRecord;
}
